import React, { Component } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { connect } from 'react-redux'
import { updatePages } from './actions/pages'
import { updateCalendar } from './actions/calendar'
import PropTypes from 'prop-types'

import './App.css'
import MainMenu from './components/mainMenu'
import Page from './components/page'
import SideMenu from './components/sideMenu'
import Footer from './components/footer'

export class App extends Component {
	static propTypes = {
		getData: PropTypes.func,
	}

	componentDidMount(){
		if(this.props.getData){
			this.props.getData()
		}
	}

	render() {
		return (
			<Router>
				<div className="App">
					<MainMenu />
					<Page />
					<SideMenu />
					<Footer />
				</div>
			</Router>
		)
	}
}

export default connect(
	() => ({}),
	dispatch => ({
		getData: () => {
			dispatch(updatePages())
			dispatch(updateCalendar())
		},
	})
)(App)



// WEBPACK FOOTER //
// ./src/App.js